import abstractModel from '../../../core/MercatelyModel';
import { MERCATELY_API } from '../../../constants/AppConstants';

const resource = `${MERCATELY_API}/campaigns`;
const templateresource = `${MERCATELY_API}/whatsapp_templates`;

const model = abstractModel(resource);

const queryParams = (params) => new URLSearchParams(params).toString();

const QR_CATALOGS = queryParams({
  timezone_is_blank: true,
  timezone: true,
  customer_columns_list: true,
  qr_contact_groups: true,
  qr_is_integrated: true,
  qr_campaign_chunk_size: true
});

const GUPSHUP_CATALOGS = queryParams({
  timezone_is_blank: true,
  qr_is_integrated: true,
  timezone: true,
  customer_columns_list: true,
  gupshup_contact_groups: true,
  gupshup_teams_templates: true,
  gupshup_types_templates: true
});

model.getQrCatalogs = async () => {
  const catalogs = await model.get({}, { path: `${resource}/catalogs?${QR_CATALOGS}` });
  return { catalogs };
};

model.getGupshupCatalogs = async () => {
  const [catalogs, templates] = await Promise.all([
    model.get({}, { path: `${resource}/catalogs?${GUPSHUP_CATALOGS}` }),
    model.get({}, { path: `${templateresource}?test=1` })
  ]);
  return { catalogs, templates };
};

model.createCampaign = async (params, retailerSlug) => model.save(
  params,
  {
    path: `/retailers/${retailerSlug}/campaigns`,
    csrfToken: document.querySelector('[name=csrf-token]').content
  }
);

export default model;
